<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForPaidPassengersForm
        ref="feesForPaidPassengersForm"
        v-model="feesForPaidPassengersFormModel"
        label-width="10em"
        formMode="edit"
        billingYmMode="search"
        :editDisabledMode="editDisabledMode"
        :autocomplete-airport-code-set="airportCodeSet"
        :autocomplete-customer-code-set="customerCodeSet"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForPaidPassengersForm from '@/components/organisms/dialog/calculation/FeesForPaidPassengersForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    FeesForPaidPassengersForm,
    EditDialogFooter
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  props: {
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForPaidPassengersFormModel: {
        billing_ym: undefined,
        bill_to_code: undefined,
        departure_airport_code: undefined,
        seats: undefined,
        paid_passengers: undefined,
        aircraft_weight_type: undefined,
        passenger_landing_fee_without_tax: undefined,
        passenger_landing_fee_tax: undefined,
        passenger_landing_fee_with_tax: undefined,
        passenger_landing_fee_before_exemption: undefined,
        tax: undefined,
        taxation: undefined,
        exemption_code: undefined,
        exemption_rate: undefined,
        unit_fee: undefined,
        landingFeeBeforeExemption: undefined,
        regist_type: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForPaidPassengersFormModel.regist_type === '1' || parseInt(this.feesForPaidPassengersFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.feesForPaidPassengersForm.validate()
        .then((valid) => {
          return this.$axios.put('/fees-for-paid-passengers', this.feesForPaidPassengersFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForPaidPassengersFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['bill_to_code', 'departure_airport_code']
      this.$nextTick(() => {
        this.$refs.feesForPaidPassengersForm.clearFields()
        Object.keys(this.feesForPaidPassengersFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.feesForPaidPassengersFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
